<template>
	<b-container v-animate-css="'fadeIn'" class="profileView">
		<b-row>
			<b-col>
				<a href="/list" class="button">Back To List</a>
			</b-col>
			<b-col>				
				<div class="formTitle">
					<svg-image image="iconID"/>
					<h5>Identity Update</h5>
				</div>
			</b-col>
			<b-col>
			</b-col>
		</b-row>
		<b-row>
			<b-col class="updateForm">
				<!-- <div id="step1">
					<h1>ABC</h1>
				</div> -->
				<div id="step2" v-if="!userProfile.profileComplete&&!fileUploaded">
					<div>
						<img class="idCard" :src="'https://repository.race.id/view/' + form.mbsdFile"/>
						<h3>{{form.mbsdIDNumber}}</h3>
					</div>
					<b-button block variant="primary" class="mb-3" v-if="form.mbsdStatus==0" @click="verifyData(form)">Approve Data</b-button>
					<b-button block variant="warning" class="mb-3" v-if="form.mbsdStatus==0||form.mbsdStatus==1" @click="updateProfile(form)">Force Reject Data</b-button>					
					<!-- <b-form @submit="onFile">
						<b-form-group id="idType-group" :label="$t('validate.id.labeltype')" label-for="idType">
							<b-form-select
								id="idType"
								v-model="form.mbsdIDNumberType"
								:options="idTypes"
								:state="formStatus.mbsdIDNumberType.state"
								required
							></b-form-select>
						</b-form-group>
						<b-form-group id="idFile-group" :label="$t('validate.id.labelfile')" label-for="idFile" :description="$t('validate.id.descfile')">
							<b-form-file
								v-model="idFile"
								:placeholder="$t('validate.id.placefile')"
								:drop-placeholder="$t('validate.id.dropfile')"
								@change="handleFileUpload"
								accept=".jpg, .png, .jpeg"
							></b-form-file>
							<b-progress class="mt-2" :max="200" height="2.5rem">
								<b-progress-bar :value="progress">
									{{progressAction}}<strong>{{ progress/2 }}</strong>
								</b-progress-bar>
							</b-progress>
							<div><label class="fileLabel">{{ $t("validate.id.labelselect") }} {{ idFile ? idFile.name : '' }}</label></div>
						</b-form-group>
						<alert :status="status"/>
						<div class="clearfix">
							<b-button block type="submit" variant="primary" :disabled="loading||!fileSelected"><b-spinner v-if="loading" small type="grow"></b-spinner> Upload new identity card</b-button>
						</div> -->
					</b-form>
				</div>
			</b-col>
			<b-col class="updateForm">
				<!--
					EDIT DATA MEMBER
					API : api/v1/member_zone/update_detail
					DATA : {"data":{"mdupMbsdId":"77333","mdupFullName":"alfian Christianto","mdupGender":"1","mdupBloodType":"0","mdupBirthPlace":"jakarta","mdupBirthDate":"1991-12-29","mdupNationality":"Indonesian","mdupCountry":"Indonesia","mdupProvinces":"DKI JAKARTA","mdupCity":"KOTA ADM. JAKARTA BARAT","mdupAddress":"Mangga Besar, Taman Sari, KOTA ADM. JAKARTA BARAT, DKI JAKARTA","mbsdStatus":"1","mdupUserUpdate":"thomas.rubhez@gmail.com"}}					
				-->
				<!-- <hr> -->
				<div id="step3">
				<!-- <div id="step3"> -->
					<!-- <div class="formTitle">
							<svg-image image="iconOne"/>
							<h5>{{ $t("validate.data.head") }}</h5>
					</div> -->
					<b-form @submit="onData">
						<b-form-group id="fullName-group" label="Full Name" label-for="fullName">
							<b-form-input
								id="fullName"
								v-model="form.mbsdFullName"
								:state="formStatus.mbsdIDNumber.state"
								required
							></b-form-input>
						</b-form-group>
						<b-form-group id="gender-group" :label="$t('signup.form.gender')" label-for="gender">
							<b-form-select
								id="gender"
								v-model="form.mbsdGender"
								:options="gender"
								required
							></b-form-select>
						</b-form-group>
						<!-- <b-form-group id="idNumber-group" :label="$t('validate.data.idlabel')" label-for="idNumber">
							<b-form-input
								id="idNumber"
								v-model="form.mbsdIDNumber"
								:state="formStatus.mbsdIDNumber.state"
								required
							></b-form-input>
						</b-form-group> -->
						<b-form-group id="birthDate-group" :label="$t('validate.data.doblabel')" label-for="birthDate"">
							<!-- <b-form-datepicker
								id="birthDate"
								v-model="form.mbsdBirthDate"
								:state="formStatus.mbsdBirthDate.state"
								required
							></b-form-datepicker> -->
							<datetime id="birthDate"
								v-model="form.mbsdBirthDate"
								:state="formStatus.mbsdBirthDate.state"
								:max-datetime="'20061115'"
								value-zone="Asia/Jakarta"
							></datetime>
						</b-form-group>
						<b-form-group id="birthPlace-group" :label="$t('validate.data.poblabel')" label-for="birthPlace">
							<gmap-autocomplete
								class="form-control"
								id="birthPlace"
								@place_changed='setBirthPlace'
								:state="formStatus.mbsdBirthPlace.state"
								:value='form.mbsdBirthPlace'
								:options="birthplaceOptions"
								required
							/>
						</b-form-group>
						<b-form-group id="bloodType-group" :label="$t('validate.data.blo')" label-for="bloodType">
							<b-form-select
								id="bloodType"
								v-model="form.mbsdBloodType"
								:options="bloodType"
								:state="formStatus.mbsdBloodType.state"
								required
							></b-form-select>
						</b-form-group>
						<b-form-group id="nationality-group" :label="$t('validate.data.nat')" label-for="nationality">
							<v-select v-model="form.mbsdNationality" :state="formStatus.mbsdNationality.state" :options="countries" label="name" :reduce="country => country.code" ></v-select>
						</b-form-group>
						<b-form-group id="country-group" :label="$t('validate.data.cou')" label-for="country">
							<v-select v-model="form.mbsdCountry" :options="countries" label="name" :state="formStatus.mbsdCountry.state" :reduce="country => country.code" @input="setCountryRestriction"></v-select>
						</b-form-group>

						<b-form-group v-if="form.mbsdCountry&&form.mbsdCountry=='ID'" id="address-group" :label="$t('validate.data.dom')" :description="$t('validate.data.domdesc')" class="addressForm" label-for="address">
							<b-form-input class="mt-2" v-model="form.mbsdAddress" :placeholder="$t('validate.data.add')"></b-form-input>
							<v-select class="mt-2" @search="fetchOptions" :options="fetchedOptions" :placeholder="$t('validate.data.cit')" label="label" @input='citySelected'/>
							<b-form-input class="mt-2" v-model="form.mbsdProvinces" :placeholder="$t('validate.data.pro')" disabled></b-form-input>
						</b-form-group>
						<b-form-group v-if="form.mbsdCountry&&form.mbsdCountry!='ID'" id="address-group" :label="$t('validate.data.dom')" label-for="address">
							<!-- <b-form-input class="mt-2" v-model="form.mbsdCity" :placeholder="$t('validate.data.cit')" disabled></b-form-input> -->
							<gmap-autocomplete
								class="form-control"
								id="address"
								@place_changed='setAddress'
								:value='form.mbsdAddress'
								:options="addressOptions"
								:state="formStatus.mbsdAddress.state"
								required
								placeholder=""
							/>
							<b-form-input class="mt-2" v-model="form.mbsdCity" :placeholder="$t('validate.data.cit')" disabled></b-form-input>
							<b-form-input class="mt-2" v-model="form.mbsdProvinces" :placeholder="$t('validate.data.pro')" disabled></b-form-input>
						</b-form-group>
						
						<!-- <b-form-group id="education-group" :label="$t('validate.data.edu')" label-for="education" description="">
							<b-form-select v-model="form.mmedEducation">
								<b-form-select-option value="Elementary">{{ $t("validate.select.edu.e1") }}</b-form-select-option>
								<b-form-select-option value="Junior">{{ $t("validate.select.edu.e2") }}</b-form-select-option>
								<b-form-select-option value="Senior">{{ $t("validate.select.edu.e3") }}</b-form-select-option>
								<b-form-select-option value="Diploma">{{ $t("validate.select.edu.e4") }}</b-form-select-option>
								<b-form-select-option value="Bachelor">{{ $t("validate.select.edu.e5") }}</b-form-select-option>
								<b-form-select-option value="Master">{{ $t("validate.select.edu.e6") }}</b-form-select-option>
								<b-form-select-option value="Doctorate">{{ $t("validate.select.edu.e7") }}</b-form-select-option>
							</b-form-select>
						</b-form-group>
						<b-form-group id="occupation-group" :label="$t('validate.data.ocu')" label-for="occupation" description="">
							<b-form-select v-model="form.mmedOccupation">
								<b-form-select-option value="Business">{{ $t("validate.select.ocu.o1") }}</b-form-select-option>
								<b-form-select-option value="Civil">{{ $t("validate.select.ocu.o2") }}</b-form-select-option>
								<b-form-select-option value="Educational">{{ $t("validate.select.ocu.o3") }}</b-form-select-option>
								<b-form-select-option value="Entrepreneur">{{ $t("validate.select.ocu.o4") }}</b-form-select-option>
								<b-form-select-option value="Freelance">{{ $t("validate.select.ocu.o5") }}</b-form-select-option>
								<b-form-select-option value="Healthcare">{{ $t("validate.select.ocu.o6") }}</b-form-select-option>
								<b-form-select-option value="Industrial">{{ $t("validate.select.ocu.o7") }}</b-form-select-option>
								<b-form-select-option value="Law">{{ $t("validate.select.ocu.o8") }}</b-form-select-option>
								<b-form-select-option value="Private">{{ $t("validate.select.ocu.o9") }}</b-form-select-option>
								<b-form-select-option value="Professional">{{ $t("validate.select.ocu.o10") }}</b-form-select-option>
								<b-form-select-option value="Student">{{ $t("validate.select.ocu.o11") }}</b-form-select-option>
								<b-form-select-option value="Unemployed">{{ $t("validate.select.ocu.o12") }}</b-form-select-option>
								<b-form-select-option value="Others">{{ $t("validate.select.ocu.o13") }}</b-form-select-option>
							</b-form-select>
						</b-form-group>
						<b-form-group id="income-group" :label="$t('validate.data.inc')" label-for="income" description="">
							<b-form-select v-model="form.mmedIncome">
								<b-form-select-option value="income1">{{ $t("validate.select.inc.i1") }}</b-form-select-option>
								<b-form-select-option value="income2">{{ $t("validate.select.inc.i2") }}</b-form-select-option>
								<b-form-select-option value="income3">{{ $t("validate.select.inc.i3") }}</b-form-select-option>
								<b-form-select-option value="income4">{{ $t("validate.select.inc.i4") }}</b-form-select-option>
								<b-form-select-option value="income5">{{ $t("validate.select.inc.i5") }}</b-form-select-option>
								<b-form-select-option value="income6">{{ $t("validate.select.inc.i6") }}</b-form-select-option>
							</b-form-select>
						</b-form-group> -->

						<!-- <b-form-checkbox
							id="acceptanceNEWS"
							v-model="checkBoxes.agreeNewsletter"
							name="acceptanceNEWS"
							value="accepted"
							unchecked-value="not_accepted"
							@change="doNewsCheckbox"
							>
							{{ $t("validate.data.accnews") }}
						</b-form-checkbox>
						<b-form-checkbox
							id="acceptance"
							v-model="checkBoxes.validIdentity"
							name="acceptance"
							value="accepted"
							unchecked-value="not_accepted"
							>
							{{ $t("validate.data.accok") }}
						</b-form-checkbox>
						<b-form-checkbox
							id="acceptanceTC"
							v-model="checkBoxes.agreeOnTnC"
							name="acceptanceTC"
							value="accepted"
							unchecked-value="not_accepted"
							>
							<div v-html="$t('validate.data.acctnp')"></div>
						</b-form-checkbox> -->
						<alert :status="status"/>
						<div class="clearfix">
							<b-button block type="submit" variant="primary" size="lg" :disabled="loading"><b-spinner v-if="loading" small type="grow"></b-spinner> Update Member Data</b-button>
						</div>
					</b-form>
				</div>
				<!-- <hr/>
				<b-card class="mt-3" header="Form Data Result">
					<pre class="m-0">{{ form }}</pre>
				</b-card>
				<b-card class="mt-3" header="Session Output">
					<pre>{{userProfile}}</pre>
				</b-card> -->
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import VuePhoneNumberInput from 'vue-phone-number-input';
   	import Alert from '../components/Alert.vue';
	import { gmapApi } from '../../node_modules/vue2-google-maps';
	import * as utils from '../util/utils';
	import SvgImage from '../components/SvgImage.vue';
	export default {
		data() {
			return {
				gender: [
					{ text: '--- Select ---', value: null },
					{ text: 'Male', value: 1 },
					{ text: 'Female', value: 2 },
				],
				fetchedOptions : [],
				fileSelected : false,
				isVerifying : false,
				isFailed : false,
				isVerified : false,
				checkBoxes : {
					validIdentity : false,
					agreeOnTnC : false
				},
				otpSent : false,
				otpError : false,
				userProfile : {},
				phoneState : {
					state : null,
					message : undefined
				},
				phoneChecked : undefined,
				progress: 0,
				idFile: undefined,
				progressAction: undefined,
				fileUploaded: undefined,
				form_ : {
					phone : undefined
				},
				birthplaceOptions : {
					types: ['(cities)'],
					// componentRestrictions: {country: "id"}
				},
				addressOptions : {
					types: [],
					// componentRestrictions: {country: "id"}
				},
				form: {
					"mbsdIDNumberType": undefined,
					"mbsdIDNumber": undefined,
					"mbsdBirthDate": undefined,
					"mbsdBirthPlace": undefined,
					"mbsdNationality": undefined,
					"mbsdCountry": undefined,
					"mbsdProvinces": undefined,
					"mbsdCity": undefined,
					"mbsdAddress": undefined,
					"mbsdRawAddress": undefined,
					"mbsdFile": undefined,
					"mbsdStatus": undefined
				},
				formPhone: {
					mbspCountryCode: undefined,
					mbspNumber: undefined
				},
				formStatus: {
					"mbsdIDNumberType": {
						state : null
					},
					"mbsdIDNumber": {
						state : null
					},
					"mbsdBirthDate": {
						state : null
					},
					"mbsdBirthPlace": {
						state : null
					},
					"mbsdNationality": {
						state : null
					},
					"mbsdCountry": {
						state : null
					},
					"mbsdProvinces": {
						state : null
					},
					"mbsdCity": {
						state : null
					},
					"mbsdAddress": {
						state : null
					},
					"mbsdRawAddress": {
						state : null
					},
					"mbsdFile": {
						state : null
					},
					"mbsdBloodType": {
						state : null
					}
				},
				idTypes: [
					{ text: 'KTP / National ID', value: 1 },
					// { text: 'SIM / Driver License', value: 1 },
					{ text: 'Paspor / Passport', value: 2 },
				],
				bloodType:[
					{ text: 'O', value: 0 },
					{ text: 'O+', value: 1 },
					{ text: 'O-', value: 2 },
					{ text: 'A', value: 3 },
					{ text: 'A+', value: 4 },
					{ text: 'A-', value: 5 },
					{ text: 'B', value: 6 },
					{ text: 'B+', value: 7 },
					{ text: 'B-', value: 8 },
					{ text: 'AB', value: 9 },
					{ text: 'AB+', value: 10 },
					{ text: 'AB-', value: 11 },
				],
				countries:[ 
					{name: 'Afghanistan', code: 'AF'}, 
					{name: 'Åland Islands', code: 'AX'}, 
					{name: 'Albania', code: 'AL'}, 
					{name: 'Algeria', code: 'DZ'}, 
					{name: 'American Samoa', code: 'AS'}, 
					{name: 'Andorra', code: 'AD'}, 
					{name: 'Angola', code: 'AO'}, 
					{name: 'Anguilla', code: 'AI'}, 
					{name: 'Antarctica', code: 'AQ'}, 
					{name: 'Antigua and Barbuda', code: 'AG'}, 
					{name: 'Argentina', code: 'AR'}, 
					{name: 'Armenia', code: 'AM'}, 
					{name: 'Aruba', code: 'AW'}, 
					{name: 'Australia', code: 'AU'}, 
					{name: 'Austria', code: 'AT'}, 
					{name: 'Azerbaijan', code: 'AZ'}, 
					{name: 'Bahamas', code: 'BS'}, 
					{name: 'Bahrain', code: 'BH'}, 
					{name: 'Bangladesh', code: 'BD'}, 
					{name: 'Barbados', code: 'BB'}, 
					{name: 'Belarus', code: 'BY'}, 
					{name: 'Belgium', code: 'BE'}, 
					{name: 'Belize', code: 'BZ'}, 
					{name: 'Benin', code: 'BJ'}, 
					{name: 'Bermuda', code: 'BM'}, 
					{name: 'Bhutan', code: 'BT'}, 
					{name: 'Bolivia', code: 'BO'}, 
					{name: 'Bosnia and Herzegovina', code: 'BA'}, 
					{name: 'Botswana', code: 'BW'}, 
					{name: 'Bouvet Island', code: 'BV'}, 
					{name: 'Brazil', code: 'BR'}, 
					{name: 'British Indian Ocean Territory', code: 'IO'}, 
					{name: 'Brunei Darussalam', code: 'BN'}, 
					{name: 'Bulgaria', code: 'BG'}, 
					{name: 'Burkina Faso', code: 'BF'}, 
					{name: 'Burundi', code: 'BI'}, 
					{name: 'Cambodia', code: 'KH'}, 
					{name: 'Cameroon', code: 'CM'}, 
					{name: 'Canada', code: 'CA'}, 
					{name: 'Cape Verde', code: 'CV'}, 
					{name: 'Cayman Islands', code: 'KY'}, 
					{name: 'Central African Republic', code: 'CF'}, 
					{name: 'Chad', code: 'TD'}, 
					{name: 'Chile', code: 'CL'}, 
					{name: 'China, People\'s Republic of', code: 'CN'}, 
					{name: 'Christmas Island', code: 'CX'}, 
					{name: 'Cocos (Keeling) Islands', code: 'CC'}, 
					{name: 'Colombia', code: 'CO'}, 
					{name: 'Comoros', code: 'KM'}, 
					{name: 'Congo', code: 'CG'}, 
					{name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
					{name: 'Cook Islands', code: 'CK'}, 
					{name: 'Costa Rica', code: 'CR'}, 
					{name: 'Cote D\'Ivoire', code: 'CI'}, 
					{name: 'Croatia', code: 'HR'}, 
					{name: 'Cuba', code: 'CU'}, 
					{name: 'Cyprus', code: 'CY'}, 
					{name: 'Czech Republic', code: 'CZ'}, 
					{name: 'Denmark', code: 'DK'}, 
					{name: 'Djibouti', code: 'DJ'}, 
					{name: 'Dominica', code: 'DM'}, 
					{name: 'Dominican Republic', code: 'DO'}, 
					{name: 'Ecuador', code: 'EC'}, 
					{name: 'Egypt', code: 'EG'}, 
					{name: 'El Salvador', code: 'SV'}, 
					{name: 'Equatorial Guinea', code: 'GQ'}, 
					{name: 'Eritrea', code: 'ER'}, 
					{name: 'Estonia', code: 'EE'}, 
					{name: 'Ethiopia', code: 'ET'}, 
					{name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
					{name: 'Faroe Islands', code: 'FO'}, 
					{name: 'Fiji', code: 'FJ'}, 
					{name: 'Finland', code: 'FI'}, 
					{name: 'France', code: 'FR'}, 
					{name: 'French Guiana', code: 'GF'}, 
					{name: 'French Polynesia', code: 'PF'}, 
					{name: 'French Southern Territories', code: 'TF'}, 
					{name: 'Gabon', code: 'GA'}, 
					{name: 'Gambia', code: 'GM'}, 
					{name: 'Georgia', code: 'GE'}, 
					{name: 'Germany', code: 'DE'}, 
					{name: 'Ghana', code: 'GH'}, 
					{name: 'Gibraltar', code: 'GI'}, 
					{name: 'Greece', code: 'GR'}, 
					{name: 'Greenland', code: 'GL'}, 
					{name: 'Grenada', code: 'GD'}, 
					{name: 'Guadeloupe', code: 'GP'}, 
					{name: 'Guam', code: 'GU'}, 
					{name: 'Guatemala', code: 'GT'}, 
					{name: 'Guernsey', code: 'GG'}, 
					{name: 'Guinea', code: 'GN'}, 
					{name: 'Guinea-Bissau', code: 'GW'}, 
					{name: 'Guyana', code: 'GY'}, 
					{name: 'Haiti', code: 'HT'}, 
					{name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
					{name: 'Holy See (Vatican City State)', code: 'VA'}, 
					{name: 'Honduras', code: 'HN'}, 
					{name: 'Hong Kong', code: 'HK'}, 
					{name: 'Hungary', code: 'HU'}, 
					{name: 'Iceland', code: 'IS'}, 
					{name: 'India', code: 'IN'}, 
					{name: 'Indonesia', code: 'ID'}, 
					{name: 'Iran, Islamic Republic Of', code: 'IR'}, 
					{name: 'Iraq', code: 'IQ'}, 
					{name: 'Ireland', code: 'IE'}, 
					{name: 'Isle of Man', code: 'IM'}, 
					{name: 'Israel', code: 'IL'}, 
					{name: 'Italy', code: 'IT'}, 
					{name: 'Jamaica', code: 'JM'}, 
					{name: 'Japan', code: 'JP'}, 
					{name: 'Jersey', code: 'JE'}, 
					{name: 'Jordan', code: 'JO'}, 
					{name: 'Kazakhstan', code: 'KZ'}, 
					{name: 'Kenya', code: 'KE'}, 
					{name: 'Kiribati', code: 'KI'}, 
					{name: 'North Korea (Democratic People\'s Republic of Korea)', code: 'KP'}, 
					{name: 'South Korea (Republic of Korea)', code: 'KR'}, 
					{name: 'Kuwait', code: 'KW'}, 
					{name: 'Kyrgyzstan', code: 'KG'}, 
					{name: 'Lao People\'s Democratic Republic', code: 'LA'}, 
					{name: 'Latvia', code: 'LV'}, 
					{name: 'Lebanon', code: 'LB'}, 
					{name: 'Lesotho', code: 'LS'}, 
					{name: 'Liberia', code: 'LR'}, 
					{name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
					{name: 'Liechtenstein', code: 'LI'}, 
					{name: 'Lithuania', code: 'LT'}, 
					{name: 'Luxembourg', code: 'LU'}, 
					{name: 'Macao', code: 'MO'}, 
					{name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
					{name: 'Madagascar', code: 'MG'}, 
					{name: 'Malawi', code: 'MW'}, 
					{name: 'Malaysia', code: 'MY'}, 
					{name: 'Maldives', code: 'MV'}, 
					{name: 'Mali', code: 'ML'}, 
					{name: 'Malta', code: 'MT'}, 
					{name: 'Marshall Islands', code: 'MH'}, 
					{name: 'Martinique', code: 'MQ'}, 
					{name: 'Mauritania', code: 'MR'}, 
					{name: 'Mauritius', code: 'MU'}, 
					{name: 'Mayotte', code: 'YT'}, 
					{name: 'Mexico', code: 'MX'}, 
					{name: 'Micronesia, Federated States of', code: 'FM'}, 
					{name: 'Moldova, Republic of', code: 'MD'}, 
					{name: 'Monaco', code: 'MC'}, 
					{name: 'Mongolia', code: 'MN'}, 
					{name: 'Montserrat', code: 'MS'}, 
					{name: 'Morocco', code: 'MA'}, 
					{name: 'Mozambique', code: 'MZ'}, 
					{name: 'Myanmar', code: 'MM'}, 
					{name: 'Namibia', code: 'NA'}, 
					{name: 'Nauru', code: 'NR'}, 
					{name: 'Nepal', code: 'NP'}, 
					{name: 'Netherlands', code: 'NL'}, 
					{name: 'Netherlands Antilles', code: 'AN'}, 
					{name: 'New Caledonia', code: 'NC'}, 
					{name: 'New Zealand', code: 'NZ'}, 
					{name: 'Nicaragua', code: 'NI'}, 
					{name: 'Niger', code: 'NE'}, 
					{name: 'Nigeria', code: 'NG'}, 
					{name: 'Niue', code: 'NU'}, 
					{name: 'Norfolk Island', code: 'NF'}, 
					{name: 'Northern Mariana Islands', code: 'MP'}, 
					{name: 'Norway', code: 'NO'}, 
					{name: 'Oman', code: 'OM'}, 
					{name: 'Pakistan', code: 'PK'}, 
					{name: 'Palau', code: 'PW'}, 
					{name: 'Palestine, State of', code: 'PS'}, 
					{name: 'Panama', code: 'PA'}, 
					{name: 'Papua New Guinea', code: 'PG'}, 
					{name: 'Paraguay', code: 'PY'}, 
					{name: 'Peru', code: 'PE'}, 
					{name: 'Philippines', code: 'PH'}, 
					{name: 'Pitcairn', code: 'PN'}, 
					{name: 'Poland', code: 'PL'}, 
					{name: 'Portugal', code: 'PT'}, 
					{name: 'Puerto Rico', code: 'PR'}, 
					{name: 'Qatar', code: 'QA'}, 
					{name: 'Reunion', code: 'RE'}, 
					{name: 'Romania', code: 'RO'}, 
					{name: 'Russian Federation', code: 'RU'}, 
					{name: 'Rwanda', code: 'RW'}, 
					{name: 'Saint Helena', code: 'SH'}, 
					{name: 'Saint Kitts and Nevis', code: 'KN'}, 
					{name: 'Saint Lucia', code: 'LC'}, 
					{name: 'Saint Pierre and Miquelon', code: 'PM'}, 
					{name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
					{name: 'Samoa', code: 'WS'}, 
					{name: 'San Marino', code: 'SM'}, 
					{name: 'Sao Tome and Principe', code: 'ST'}, 
					{name: 'Saudi Arabia', code: 'SA'}, 
					{name: 'Senegal', code: 'SN'}, 
					{name: 'Serbia and Montenegro', code: 'CS'}, 
					{name: 'Seychelles', code: 'SC'}, 
					{name: 'Sierra Leone', code: 'SL'}, 
					{name: 'Singapore', code: 'SG'}, 
					{name: 'Slovakia', code: 'SK'}, 
					{name: 'Slovenia', code: 'SI'}, 
					{name: 'Solomon Islands', code: 'SB'}, 
					{name: 'Somalia', code: 'SO'}, 
					{name: 'South Africa', code: 'ZA'}, 
					{name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
					{name: 'Spain', code: 'ES'}, 
					{name: 'Sri Lanka', code: 'LK'}, 
					{name: 'Sudan', code: 'SD'}, 
					{name: 'Suriname', code: 'SR'}, 
					{name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
					{name: 'Eswatini (Swaziland)', code: 'SZ'}, 
					{name: 'Sweden', code: 'SE'}, 
					{name: 'Switzerland', code: 'CH'}, 
					{name: 'Syrian Arab Republic', code: 'SY'}, 
					{name: 'Taiwan (Republic of China)', code: 'TW'}, 
					{name: 'Tajikistan', code: 'TJ'}, 
					{name: 'Tanzania, United Republic of', code: 'TZ'}, 
					{name: 'Thailand', code: 'TH'}, 
					{name: 'Timor-Leste', code: 'TL'}, 
					{name: 'Togo', code: 'TG'}, 
					{name: 'Tokelau', code: 'TK'}, 
					{name: 'Tonga', code: 'TO'}, 
					{name: 'Trinidad and Tobago', code: 'TT'}, 
					{name: 'Tunisia', code: 'TN'}, 
					{name: 'Turkey', code: 'TR'}, 
					{name: 'Turkmenistan', code: 'TM'}, 
					{name: 'Turks and Caicos Islands', code: 'TC'}, 
					{name: 'Tuvalu', code: 'TV'}, 
					{name: 'Uganda', code: 'UG'}, 
					{name: 'Ukraine', code: 'UA'}, 
					{name: 'United Arab Emirates', code: 'AE'}, 
					{name: 'United Kingdom', code: 'GB'}, 
					{name: 'United States', code: 'US'}, 
					{name: 'United States Minor Outlying Islands', code: 'UM'}, 
					{name: 'Uruguay', code: 'UY'}, 
					{name: 'Uzbekistan', code: 'UZ'}, 
					{name: 'Vanuatu', code: 'VU'}, 
					{name: 'Venezuela', code: 'VE'}, 
					{name: 'Vietnam', code: 'VN'}, 
					{name: 'Virgin Islands, British', code: 'VG'}, 
					{name: 'Virgin Islands, U.S.', code: 'VI'}, 
					{name: 'Wallis and Futuna', code: 'WF'}, 
					{name: 'Western Sahara', code: 'EH'}, 
					{name: 'Yemen', code: 'YE'}, 
					{name: 'Zambia', code: 'ZM'}, 
					{name: 'Zimbabwe', code: 'ZW'} 
				],
				signedin : true,
				data: null,
				status: null,
				loading:false,
				checkingPhone: false,
				resetPasswordSent: false,
				fileError: undefined,
				showLater : false
			}
		},
		computed : {
			isLoggedIn : function(){ 
				// console.log('is this one logged in? ', this.$store.getters.isLoggedIn);
				return this.$store.getters.isLoggedIn
			},
			showResend : function(){
				return true
			},
			// getProfile : function(){
			// 	const userProfile = this.$store.getters.getUserProfile;
			// 	if (userProfile.phoneData){
			// 		this.formPhone = userProfile.phoneData;
			// 	}
			// 	return userProfile;
			// }
		},
		components : {
			Alert,
			gmapApi,
			VuePhoneNumberInput,
			SvgImage,
		},
		methods: {
			verifyData(row){
				this.$store.dispatch('VERIFYDATA', {fileId:row.mbsdFile})
					.then(s=>{
						row.mbsdStatus = 1;
						// this.enabled = false;
						console.log(s);
					})
					.catch(e=>{
						console.log(e);
					})
				console.log(row);
			},
			updateProfile(row){
				console.log('Initiate update profile... ', row, this);
				this.form.mbsdStatus = 0;

				const dataToSend = {
					"mdupMbsdId": this.form.mbsdId,
					"mdupFullName": this.form.mbsdFullName,
					"mdupGender": this.form.mbsdGender,
					"mdupBloodType": this.form.mbsdBloodType,
					"mdupBirthPlace": this.form.mbsdBirthPlace,
					"mdupBirthDate": this.form.mbsdBirthDate,
					"mdupNationality": this.form.mbsdNationality,
					"mdupCountry": this.form.mbsdCountry,
					"mdupProvinces": this.form.mbsdProvinces,
					"mdupCity": this.form.mbsdCity,
					"mdupAddress": this.form.mbsdAddress,
					"mbsdStatus": this.form.mbsdStatus,
					"mdupUserUpdate": this.userProfile.email
				}
				this.$store.dispatch('UPDATEMEMBERDATA', {data:dataToSend})
					.then((signUp) =>{
						this.loading = false;
				// 		this.userProfile.profileComplete = true;
						// this.init();
						console.log('Done update ... ', signUp)
				// 		// this.$router.push('/signup/otp')
						this.$store.dispatch('CHANGEPROFILE', {data:row.mbsdFile})
							.then(s=>{
								this.$router.push('/list');
								// this.loadItems(this.page);
								// row.item.mbsdStatus = 1;
								// this.enabled = false;
								console.log(s);
							})
							.catch(e=>{
								this.parseError(e);
								console.log(e);
							})
					})
					.catch(err => {
						this.parseError(err);
						if (err.response){
							this.status = err.response;
						}
						this.loading = false;
					})
					
				// this.onData().then(()=>{				
				// })
				// this.$store.dispatch('UPDATEMEMBERDATA', {data:{ mdupMbsdId: row.mbsdId, mbsdStatus: 0 }}).then(updateDone=>{
				// 	console.log(updateDone);
				// })
				// {"data":{"mdupMbsdId":"77333","mdupFullName":"alfian Christianto","mdupGender":"1","mdupBloodType":"0","mdupBirthPlace":"jakarta","mdupBirthDate":"1991-12-29","mdupNationality":"Indonesian","mdupCountry":"Indonesia","mdupProvinces":"DKI JAKARTA","mdupCity":"KOTA ADM. JAKARTA BARAT","mdupAddress":"Mangga Besar, Taman Sari, KOTA ADM. JAKARTA BARAT, DKI JAKARTA","mbsdStatus":"1","mdupUserUpdate":"thomas.rubhez@gmail.com"}}	
				// this.$store.dispatch('UPDATEMEMBERDATA', {data:row})

			},
			resetPassword(){
				console.log(this.form)
				this.$store.dispatch('RESETPASSWORD', {data:{email:this.userProfile.profileData.mbsdEmail}})
					.then((resetOut) =>{
						this.loading = false;
						this.resetPasswordSent = true;
					})
					.catch(err => {
						this.loading = false;
						this.validation = false;
						if (err.response){
							this.status = err.response;
						}
					})
				// RESETPASSWORD
			},
			validateLater(){
				this.userProfile.phoneVerified = true;
			},
			citySelected(s){
				if (s.mskbProvinsi){				
					this.form.mbsdProvinces = s.mskbProvinsi;
					this.form.mbsdRawAddress = this.form.mbsdAddress;
					this.form.mbsdCity = s.mskbKabupaten;
				}
				// console.log('Selected : ',s);
			},
			fetchOptions(search, isLoading){
				if (search&&search.length > 2){				
					isLoading = true;
					this.doSearch(isLoading, search, this);
				}
			},
			doSearch(isLoading, search, vm){
				this.$store.dispatch('GETRESOURCE', {source:'masterKabupaten', params:{
						sort: 'mskbId',
						filter:{mskbKabupaten:{like:'%'+search+'%'}}}
					}).then(resources=>{
						if (resources.data.data&&resources.data.data.length > 0){
							resources.data.data.forEach(function(d){
								d.label = d.mskbKabupaten + ' - ' + d.mskbProvinsi
								// console.log(d);
							})
							vm.fetchedOptions = resources.data.data;
						}
						isLoading = false;
						// console.log(resources, vm);
					})
			},
			photoProfileError(event){
				event.target.src = "/public/images/anonymous.jpg"
				// console.log(this, event)
			},
			resetPhone(){
				this.otpSent = false;
				// this.userProfile.phoneData = {};
				// otpError
			},
			validatePhoneOTP(evt){
				this.$store.dispatch('VERIFYPHONE', {data:this.formPhone.otpCode})
					.then((phoneVerificationOut) =>{
						this.loading = false;
						console.log('A: ', phoneVerificationOut.data);
						// if (phoneVerificationOut.data.status='OK'){
							// this.showOtp = false;
							// console.log('B: ',signUp)
							this.$router.push('/');
							this.status = null;
						// }
					})
					.catch(err => {
						// console.log(err)
						// this.parseError(err);
						if (err.response){
							this.status = err.response;
							this.phoneState.state = false;
							this.phoneState.message = utils.stringifyErrors(err.response);
							this.otpError = true;
						} else {
							this.status = {data:{status:{error:{message:'Verification failed, please report this problem to info@borobudurmarathon.com'}}}}
						}
						this.loading = false;
					})
			},
			handleFileUpload(e){
				console.log(e)
				this.fileSelected = true;
			},
			parseError(err){
				if (err.response&&err.response.data&&err.response.data.status&&err.response.data.status.error){
					console.log('E1: ', err.response.data.status.error)
					console.log('E2: ', err.response.data.status.error.errors)
					if (err.response.data.status.error.errors&&err.response.data.status.error.errors.length > 0){
						err.response.data.status.error.errors.forEach((errors)=>{
							console.log('E3: ', errors);
							if (Array.isArray(errors)){
								errors.forEach((error)=>{
									console.log('E4: ', error);	
									if (this.formStatus[error.field]){									
										this.formStatus[error.field].state = false;
										this.formStatus[error.field].message = error.message;
									} else {
										console.log(error.field, ' not defined.');
									}
								})
							}
						})
					}
				}
			},
			setCountryRestriction(country){
				console.log('restrict google address search to : ', country);
				this.addressOptions.componentRestrictions = {country:country};
			},
			setAddress(place){
				var placeOut = utils.gParser(place);
				this.form.mbsdProvinces = placeOut.province;
				this.form.mbsdCity = placeOut.kabupaten;
				this.form.mbsdAddress = placeOut.address;
				this.form.mbsdRawAddress = placeOut.raw;
				console.log(placeOut);
			},
			setBirthPlace(place){
				this.form.mbsdBirthPlace = place.formatted_address;
				// console.log(place.formatted_address);
			},
			startChecking() {
				if (this.fileCheckingInterval){
					clearInterval(this.fileCheckingInterval);
				}
				this.fileCheckingInterval = setInterval(()=>{
					this.$store.dispatch('CHECKID', {data:this.form})
						.then(validationOut=>{
							console.log('Validation Output : ', validationOut)
							if (validationOut.data.data.fivaStatus < 0){
								console.log('Unable to read document... ');
								this.fileUploaded = false;
								this.fileError = true;
								clearInterval(this.fileCheckingInterval);
							} else if (validationOut.data.data.fivaStatus > 1){
								console.log('Document OK ... ', validationOut.data.data);
								clearInterval(this.fileCheckingInterval);								
							}
						})
						.catch(err=>{
							console.log('Validation Err : ', err)
						})
					// this.checkId(data)
					// 	.then(checkResponse=>{
					// 		console.log(checkResponse);
					// 	})
					// 	.catch(err=>{
					// 		clearInterval(this.startChecking) 
					// 	})
				}, 5000);
			},
			onFile(evt){
				this.loading = true;
				evt.preventDefault()
				this.progressAction = 'Uploading File...';
				let formData = new FormData();
				let idType = 'ktp';
				if (this.form.mbsdIDNumberType == 1){
					idType = 'sim';
				} else if (this.form.mbsdIDNumberType == 2){
					idType = 'passport';
				}
				formData.append(idType,this.idFile);
				console.log('Process upload...');
				// console.log(formData);
				this.$store.dispatch('UPLOADID', {data:formData, progressEvent:(progressEvent)=>{
					this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 200 ))
					// console.log('progress : ', this.progress)
				}}).then((uploadOut) =>{
						this.loading = false;
						var fileUploadOut = uploadOut.data;
						this.form.mbsdFile = fileUploadOut.processingId;
						console.log('Upload success : ', fileUploadOut);
						this.fileUploaded = true;
						// this.startChecking(this.form);
					})
					.catch(err => {
						this.parseError(err);
						// if (err.response){
						// 	this.status = err.response;
						// }
						this.loading = false;
					})

			},
			onFileOldValidator(evt){
				this.loading = true;
				evt.preventDefault()
				this.progressAction = 'Uploading File...';
				let formData = new FormData();
				formData.append('file',this.idFile);
				// console.log(formData);
				this.$store.dispatch('UPLOADID', {data:formData, progressEvent:(progressEvent)=>{
					this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))
					// console.log('progress : ', this.progress)
				}}).then((uploadOut) =>{
						this.loading = true;
						var fileUploadOut = uploadOut.data;
						console.log('Upload success : ', fileUploadOut);
						var dataToExtract = {
							url : fileUploadOut.file.path,
							cardtype : this.form.mbsdIDNumberType
						}
						this.form.mbsdFile = fileUploadOut.file.path;
						this.progressAction = 'Validating File...';
						this.progress = 150;
						this.$store.dispatch('EXTRACTID', {data:dataToExtract})
							.then((extractionOut) =>{
								this.loading = false;
								this.progress = 200;
								this.progressAction = 'File processed!';
								console.log('output of extraction : ', extractionOut.data)
								this.form.mbsdIDNumber = extractionOut.data.data.nik;
								this.form.mbsdBirthDate = extractionOut.data.data.tanggal_lahir.split("-").reverse().join("-");
								this.form.mbsdBirthPlace = extractionOut.data.data.tempat_lahir;
								this.form.mbsdNationality = 'Indonesia';
								this.form.mbsdCountry = 'Indonesia';
								this.form.mbsdProvinces =  extractionOut.data.data.province;
								this.form.mbsdCity = extractionOut.data.data.city;
								this.form.mbsdAddress = extractionOut.data.data.alamat;
								this.form.mbsdRawAddress = JSON.stringify(extractionOut);
								// "mbsdFile": 'MUSTVALIDATE'
								// this.$router.push('/signup/otp')
								// this.init();
							})
							.catch(err => {
								// this.parseError(err);
								if (err.response){
									this.status = err.response;
								}
								this.loading = false;
							})
						// var 
						// this.$router.push('/signup/otp')
						// this.init();
					})
					.catch(err => {
						this.parseError(err);
						// if (err.response){
						// 	this.status = err.response;
						// }
						this.loading = false;
					})
			},
			onPhone(evt){
				evt.preventDefault()
			},
			onData(evt){
				evt.preventDefault();
				this.loading = true;
				this.userProfile = this.$store.getters.getUserProfile;
				console.log('Do profile... ', this.form, this.userProfile);
				const dataToSend = {
					"mdupMbsdId": this.form.mbsdId,
					"mdupFullName": this.form.mbsdFullName,
					"mdupGender": this.form.mbsdGender,
					"mdupBloodType": this.form.mbsdBloodType,
					"mdupBirthPlace": this.form.mbsdBirthPlace,
					"mdupBirthDate": this.form.mbsdBirthDate,
					"mdupNationality": this.form.mbsdNationality,
					"mdupCountry": this.form.mbsdCountry,
					"mdupProvinces": this.form.mbsdProvinces,
					"mdupCity": this.form.mbsdCity,
					"mdupAddress": this.form.mbsdAddress,
					"mbsdStatus": this.form.mbsdStatus,
					"mdupUserUpdate": this.userProfile.email
				}
				this.$store.dispatch('UPDATEMEMBERDATA', {data:dataToSend})
					.then((signUp) =>{
						this.loading = false;
				// 		this.userProfile.profileComplete = true;
						this.init();
						console.log('Done update ... ', signUp)
				// 		// this.$router.push('/signup/otp')
					})
					.catch(err => {
						this.parseError(err);
						if (err.response){
							this.status = err.response;
						}
						this.loading = false;
					})

			},
			phoneUpdated(value){
				this.formPhone.mbspCountryCode = value.countryCallingCode;
				this.formPhone.mbspNumber = parseInt(value.phoneNumber.replace(/\D/g,''));
				// console.log(value);
			},
			sendOTP(event){
				console.log(this.formPhone)
				this.$store.dispatch('ADDPHONE', {data:this.formPhone})
					.then((addPhone) =>{
						this.loading = false;
						this.otpSent = true;
						console.log(addPhone)
						// this.$router.push('/signup/otp')
						// this.init();
					})
					.catch(err => {
						console.log('add phone error : ', err)
						// this.parseError(err);
						if (err.response){
							this.status = err.response;
						}
						this.loading = false;
					})
			},
			// updateProfile(){
			// 	console.log('Initiate update profile... ', this.userProfile.profileData.mbsdFile);
			// 	this.$store.dispatch('CHANGEPROFILE', {data:this.userProfile.profileData.mbsdFile})
			// 		.then(changeRequestSuccess=>{
			// 			this.userProfile.profileComplete = false;
			// 		})
			// 		.catch(err=>{
			// 			if (err.response){
			// 				this.status = err.response;
			// 			}
			// 		})

			// },
			doNewsCheckbox(e){
				if (e == 'accepted'){
					this.$store.dispatch('AGREENEWS', {data:{id:1}})
				}
				// this.
				// console.log(e);
			},
			init(){
				var params = {
					params : {
						filter : {
							mbsdId : this.$route.params.dataId
						}
					}
				};

				this.$store.dispatch('GETMEMBERS', params)
					.then(members => {
						console.log(members.data.data[0], this.$route.params.dataId, this.form)
						this.form = members.data.data[0];
					})

				// this.$store.dispatch('GETPROFILE')
				// 	.then((profileOut)=>{
				// 		this.$store.commit('SET_USER', {id: profileOut.data.data[0].id, user: profileOut.data});
				// 		this.userProfile = this.$store.getters.getUserProfile;
				// 		if (this.userProfile.memberLanguage){
				// 			// console.log('language : ', this.userProfile.memberLanguage)
				// 			if (this.userProfile.memberLanguage == 2){
				// 				this.$i18n.locale = 'id';
				// 			} else {
				// 				this.$i18n.locale = 'en';
				// 			}
				// 		}
				// 		if (!this.userProfile.phoneVerified){
				// 			// console.log(this.userProfile);
				// 			if (this.userProfile.phoneData){
				// 				this.form_.phone = this.userProfile.phoneData.mbspNumber;
				// 				this.formPhone = userProfile.phoneData;
				// 			}
				// 		}
				// 		if (this.userProfile.profileComplete){
				// 			if (this.userProfile.profileData.mbsdStatus >= 1){
				// 				this.isVerifying = false;
				// 				this.isVerified = true;
				// 			} else {
				// 				this.$store.dispatch('VALIDATEID', {data:this.userProfile.profileData})
				// 					.then(validationOut=>{
				// 						console.log('Validation Output : ', validationOut.data)
				// 						if (!validationOut.data.verified){
				// 							this.isVerifying = false;
				// 							this.isFailed = true;
				// 						}
				// 						if (validationOut.data.verifying){
				// 							this.isVerifying = true;
				// 						}
				// 					})
				// 					.catch(err=>{
				// 						this.isVerifying = false;
				// 						this.isFailed = true;
				// 					})

				// 			}
				// 		}
				// 		console.log('Out profile : ', this.userProfile);
				// 	})
				// 	.catch((err)=>{
				// 		console.log('profile error : ', err)
				// 	})				
			}
		},
		mounted(){
			this.$store.commit('ACTIVATE_ADMIN');

			this.$store.dispatch('CHECK')
				.then((checkOut) =>{
					console.log('CO : ', checkOut);
					this.data = checkOut.data;
					this.init();
				})
				.catch(err => {
					console.log(err);
				})
		},
	}
</script>


// WEBPACK FOOTER //
// ProfileUpdate.vue